import "babel-polyfill";
import React from "react";
import Modal from "react-modal";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import store from "./config/createStore";

import "./index.css";
import App from "./App";
import { unregisterAll } from "./registerServiceWorker";
import { captureSupportLink } from "./support/deepLink";

// Before the router reads the address: a support reply email's link (?support=) waits for the
// composer and leaves the address bar, so the sign-in redirect doesn't carry it.
captureSupportLink();

let persistor = persistStore(store);

const app = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
Modal.setAppElement(document.getElementById("root"));

ReactDOM.render(app, document.getElementById("root"));
// The site no longer uses a service worker. Remove any old one this browser still has.
unregisterAll();



// WEBPACK FOOTER //
// ./src/index.js